<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submit"
    :submit-btn-text="item.id ? 'Update' : 'Create'"
  >
    <template slot="header">
      <span>{{ item.id ? 'Update' : 'Create' }} Truck Type</span>
    </template>
    <template slot="body">
      <v-row>
        <v-col
          cols="8"
          class="pb-0"
        >
          <v-text-field
            v-model="item.name"
            :rules="[(v) => !!v || 'Name is required']"
          >
            <template slot="label">
              Name<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
        <v-col
          cols="4"
          class="pb-0"
        >
          <v-text-field
            v-model="item.weight_limit"
            :rules="[(v) => !!v || 'Weight limit is required']"
            type="number"
            min="0"
            suffix="kg"
          >
            <template slot="label">
              Weight Limit<RedAsterisk />
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <span style="color: #000000; font-size: 16px;">Select Color</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-color-picker
            v-model="color"
            hide-canvas
            mode="hexa"
            hide-inputs
            hide-mode-switch
            swatches-max-height="100"
          />
        </v-col>
      </v-row>
    </template>
  </the-dialog-box>
</template>

<script>

export default {
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      name: '',
      weight_limit: null,
      color: null,
    },
    color: null,
  }),
  created() {
    this.item = { ...this.itemDto };
  },
  methods: {

    async get(id) {
      if (!id) return;
      const submitModel = {
        filters: {
          id,
        },
      };
      const res = await this.$api.truckScheduleTruckType.read(submitModel);
      if (!res || res.length < 1 || !res[0]) return;
      const firstIndex = 0;
      this.item = res[firstIndex];
    },

    async submit() {
      if (!this.item) return false;
      let res;
      this.item.color = this.color.hex;
      if (this.item.id) {
        res = await this.$api.truckScheduleTruckType.update(this.item);
      } else {
        res = await this.$api.truckScheduleTruckType.store(this.item);
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$emit('success');
      return res;
    },

    open(id) {
      if (id) {
        this.item.id = id;
        this.get(id);
      } else {
        this.item = { ...this.itemDto };
      }
      this.$refs.dialogBox.open();
    },
  },
};
</script>
